import { postalCodeElements } from '@flows/configs/petHealthV2/steps/elements/postalCode'
import { v2PetPortrait } from '@flows/configs/petHealthV2/steps/elements/shared'
import {
  hasCustomerZipCode,
  postalCodeErrorMap,
  validateZipCode,
} from '@flows/configs/petHealthV2/utils'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const postal_code = (params: StepConfigParams) => {
  const fragment = postalCodeElements(params)

  return {
    ...fragmentStep(
      { ...fragment, elements: [v2PetPortrait(params), ...fragment.elements] },
      params,
      'pet_quote'
    ),
    errorMap: postalCodeErrorMap,
    skipStep: { condition: hasCustomerZipCode, targetStepName: 'pet_quote' },
    onSubmit: { type: 'simpleHook', callback: validateZipCode(params) },
  } as const satisfies AnyStepConfiguration
}

export default postal_code
